module.exports = __webpack_public_path__ + "static/media/ic_dust.fa7e6acb.png";